module.exports = __webpack_public_path__ + "img/Font 16.8b603cdc.jpg";